import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    // Scoll to top for all routes
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'LevelOne',
      component: () => import(/* webpackChunkName: "lv1View" */ "@/views/LevelOneView.vue"),
      beforeEnter: (to, from, next) => {
        console.log("App.vue - resetting the state for the query");
        store.commit('resetQuery');
        return next();
      }
    },
    {
      path: '/:id(\\d+)',
      name: 'LevelThree',
      component: () => import(/* webpackChunkName: "lv3View" */ "@/views/LevelThreeView.vue"),
      children: [
        {
          path: "",
          name: "ListingDetailView",
          component: () => import(/* webpackChunkName: "lv3ListingDetailView" */ "@/views/listing/ListingDetailView.vue"),
        },
        {
          path: "booking",
          name: "BookingView",
          component: () => import(/* webpackChunkName: "lv3ListingBookingView" */ "@/views/booking/BookingView.vue"),
        },
        {
          path: "booking/success",
          name: "BookingSuccess",
          component: () => import(/* webpackChunkName: "lv3ListingBookingSuccessView" */ "@/views/booking/BookingSuccess.vue"),
        }
      ]
    },
    {
      path: '/not-found',
      name: '404',
      component: () => import(/* webpackChunkName: "notFoundView" */ '@/views/NotFound.vue'),
    },
    {
      path: '/error',
      name: 'ErrorView',
      component: () => import(/* webpackChunkName: "errorView" */ '@/views/ErrorView.vue'),
    },
    {
      path: "/dev",
      name: "DEV",
      component: () => import(/* webpackChunkName: "devView" */ "@/views/dev/DevView.vue")
    },
    {
      path: '/:regionOrSearch',
      name: 'LevelTwo',
      component: () => import(/* webpackChunkName: "lv2ViewSearchView" */ "@/views/LevelTwoView.vue"),
    },
    {
      path: '*',
      redirect: "/not-found"
    },
  ]
})
